import React from 'react';
import {Flex} from '/app/src/component';

export default ({meta, ...rest }) => {
    let isImage = (/\.(gif|jpg|jpeg|tiff|png)$/i).test(meta.details.file_name)
    return (
        <Flex column center>
            <Flex color='black' marginBottom='10px'>
            {meta.details.user_name} {'har lagt till en fil: '}
                <a download={meta.details.file_name} target="_blank" href={meta.details.url}>
                    {meta.details.file_name}
                </a>
            </Flex>
            <Flex center>
                {isImage && <img alt='' style={{width: '60%', height: 'auto'}} src={meta.details.url}/>}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Message/_MetaFileMessage.js